import { render, staticRenderFns } from "./MarkedUpImagesGalleryFullscreenModal.vue?vue&type=template&id=f30d1994&"
import script from "./MarkedUpImagesGalleryFullscreenModal.vue?vue&type=script&lang=ts&"
export * from "./MarkedUpImagesGalleryFullscreenModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports